import { Form } from 'antd'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'

import { useStore } from 'store/useStore'
import { Margin } from 'components/ui'
import { Flex, Input, Paragraph, Popover, Text, Title } from 'components/uiKit'
import { useResize } from 'utils/hooks/useResize'
import { widths } from 'shared/constants/values'

type FormType = {
  ownerGln: string
  glnPvz: string
  molName: string
}

export const OrderBYCompanyForm = observer(() => {
  const { activateOrderUiStore: uiStore } = useStore()
  const [form] = Form.useForm()
  const { isMobile } = useResize()

  const email = 'info@edn.by'

  useEffect(() => {
    if (uiStore.initialized) {
      form.setFieldsValue({
        molName: uiStore.molName,
        glnPvz: uiStore.glnPvz,
        ownerGln: uiStore.ownerGln,
      })
    }
  }, [uiStore.initialized])

  return (
    <Form layout="vertical" form={form} requiredMark={false}>
      <Margin mb={8}>
        <Flex gap={10}>
          <Title level={5}>Формирование электронной ТТН</Title>

          <Popover
            trigger={'click'}
            placement={isMobile ? 'bottom' : 'rightTop'}
            content={
              <Flex vertical style={{ maxWidth: widths.mobile }}>
                <Paragraph>
                  В связи с обновлением законодательства всем ПВЗ в Республике Беларусь необходимо подключиться к
                  системе ЭДиН — системе электронного документооборота
                </Paragraph>
                <Paragraph>
                  Для подключения к ЭДиН нужно получить GLN — единый международный идентификационный номер
                </Paragraph>
                <Paragraph>
                  Чтобы получить GLN, консультацию и индивидуальный тариф, отправьте письмо на почту{' '}
                  <Text copyable strong>
                    {email}
                  </Text>
                </Paragraph>
                <Paragraph>В нём укажите следующие данные:</Paragraph>
                <Paragraph>
                  <ul style={{ listStyleType: 'disc', margin: 0 }}>
                    <li>
                      <Text>тема письма: «Партнёр WB ПВЗ, ФИО, УНП»</Text>
                    </li>
                    <li>
                      <Text>текст письма: «Прошу предоставить консультацию по подключению к ЭДиН»</Text>
                    </li>
                  </ul>
                </Paragraph>
                <Paragraph>Также обязательно укажите номер телефона для связи</Paragraph>
              </Flex>
            }
          >
            <QuestionCircleOutlined style={{ color: '#00000073' }} />
          </Popover>
        </Flex>
      </Margin>

      <Form.Item<FormType>
        label={'GLN юридического лица'}
        name={'ownerGln'}
        rules={[{ required: true, message: 'Поле обязательно' }]}
      >
        <Input
          value={uiStore.ownerGln}
          onChange={(e) => uiStore.setOwnerGln(e.target.value)}
          placeholder="Введите GLN вашего юридического лица"
        />
      </Form.Item>

      <Form.Item<FormType> label={'GLN ПВЗ'} name={'glnPvz'} rules={[{ required: true, message: 'Поле обязательно' }]}>
        <Input
          value={uiStore.glnPvz}
          onChange={(e) => uiStore.setGlnPvz(e.target.value)}
          placeholder="Введите GLN вашего будущего ПВЗ"
        />
      </Form.Item>

      <Form.Item<FormType> label={'МОЛ'} name={'molName'} rules={[{ required: true, message: 'Поле обязательно' }]}>
        <Input
          value={uiStore.molName}
          onChange={(e) => uiStore.setMolName(e.target.value)}
          placeholder="Введите ФИО материально ответственного лица"
        />
      </Form.Item>
    </Form>
  )
})
